export function getFileUploadId(): string {
	return `addFile_${Date.now()}_${Math.floor(Math.random() * 1000)}.jpeg`;
}
export function genAWSUploadId(): string {
	// THIS RETURNS A RANDOM STRING OF NUMBERS THAT IS 16 DIGITS LONG
	// TODO: IS THIS THE BEST WAY TO DO THIS?
	return `${Math.random().toString().split('.')[1]}`;
}
